// ShipListItemContent.tsx
import React from 'react';
import { ShipList } from '@ais-ui/api-spec/config';
import { useLocalization } from '@ais-ui/locale-management';
import { isNonEmpty } from '@ais-ui/utils';

interface ShiplistGridItemProps {
  label: string;
  value: string | undefined | null;
}

const ShiplistGridItem = ({ label, value }: ShiplistGridItemProps) => {
  return (
    <div className="flex flex-col gap-1">
      <p className="text-sm font-medium flex-none">{label}</p>
      <p className="text-sm text-gray-500 dark:text-gray-400 flex-grow text-ellipsis overflow-hidden">
        {isNonEmpty(value) ? value : 'Unknown'}
      </p>
    </div>
  );
};

interface ShipListItemContentProps {
  shiplist: ShipList;
}

export const ShipListItemContent = ({ shiplist }: ShipListItemContentProps) => {
  const { messages } = useLocalization();

  return (
    <div className="grid gap-6 px-4 pt-4">
      <div className="grid gap-4">
        <div className="grid grid-cols-2 gap-4">
          <ShiplistGridItem
            label={messages.shiplistsItemOwnerLabel}
            value={shiplist.owner}
          />
          <ShiplistGridItem
            label={messages.shiplistsItemShareLabel}
            value={
              shiplist.acl && shiplist.acl.length > 0
                ? shiplist.acl.map((groupName) => groupName).join(', ')
                : messages.shiplistsItemShareNoValue
            }
          />
        </div>
      </div>
    </div>
  );
};
